<app-data-table [colFields]="colFields" [tableData]="tableData"></app-data-table>